import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons'
import { Button, Dropdown } from 'antd'
import type { MenuProps } from 'antd'

type ProductActionMenuProps = {
  canDelete: boolean
  canEdit: boolean
  menuClassName: string
  onDelete: () => void
  onEdit: () => void
  showDisabledWhenEmpty?: boolean
  triggerClassName: string
}

function ProductActionMenu({
  canDelete,
  canEdit,
  menuClassName,
  onDelete,
  onEdit,
  showDisabledWhenEmpty = false,
  triggerClassName,
}: ProductActionMenuProps) {
  if (!canEdit && !canDelete) {
    if (!showDisabledWhenEmpty) return null

    return (
      <Button
        aria-label="Product actions unavailable"
        className={`${triggerClassName} ${triggerClassName}-disabled ant-dropdown-trigger`}
        disabled
      >
        <MoreOutlined />
      </Button>
    )
  }

  const actionItems: MenuProps['items'] = [
    canEdit
      ? {
          key: 'edit',
          className: 'menuButton',
          label: (
            <Button
              size="large"
              onClick={(event) => {
                event.stopPropagation()
                onEdit()
              }}
            >
              <EditOutlined />
              Edit
            </Button>
          ),
        }
      : null,
    canDelete
      ? {
          key: 'delete',
          className: 'menuButton',
          label: (
            <Button
              size="large"
              onClick={(event) => {
                event.stopPropagation()
                onDelete()
              }}
            >
              <DeleteOutlined />
              Delete
            </Button>
          ),
        }
      : null,
  ].filter(Boolean) as MenuProps['items']

  return (
    <Dropdown
      trigger={['click']}
      menu={{ className: menuClassName, items: actionItems }}
    >
      <Button
        aria-label="Product actions"
        className={triggerClassName}
        onClick={(event) => event.stopPropagation()}
      >
        <MoreOutlined />
      </Button>
    </Dropdown>
  )
}

export default ProductActionMenu
